import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import {
  CreateInvoicePayload,
  Invoice,
  InvoiceStatus,
} from "../types/feesAndPaymentType";
import { toast } from "sonner";

export interface GetInvoiceParams {
  branchCode: string;
  schoolCode: string;
  paymentTitle?: string;
  page: number;
  size: number;
}

export interface InvoiceStats {
  pending: number;
  paid: number;
  partial: number;
  draft: number;
  scheduled: number;
}

const feesAndPaymentApis = {
  getInvoices: (params: GetInvoiceParams) =>
    customFetch.get<ApiResponse<any>>("/api/v1/fee-and-payment/invoice", {
      params,
    }),

  getInvoiceStats: (branchCode: string) =>
    customFetch.get<ApiResponse<InvoiceStats>>(
      "/api/v1/fee-and-payment/invoice/stats",
      { params: { branchCode } },
    ),

  createInvoice: async (
    payload: CreateInvoicePayload,
    status: InvoiceStatus,
  ) => {
    try {
      const res = await customFetch.post<ApiResponse<any>>(
        `/api/v1/fee-and-payment/invoice?status=${status}`,
        payload,
      );

      return res.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.message || "Failed to create invoice";
      toast.error(message);
      throw error;
    }
  },

  deleteTemplate: async (invoiceId: number) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/fee-and-payment/invoice/${invoiceId}`,
      );

      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete invoice");
      throw err;
    }
  },

  deleteInvoiceItem: async (invoiceId: number) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/fee-and-payment/invoice/item/${invoiceId}`,
      );

      return response.data;
    } catch (err: any) {
      toast.error(err?.response?.data?.message || "Failed to delete invoice");
      throw err;
    }
  },

  updateInvoiceStatus: async (
    invoiceId: number,
    status: InvoiceStatus,
    amount: number,
  ) => {
    try {
      const response = await customFetch.put<ApiResponse<any>>(
        `/api/v1/fee-and-payment/invoice/${invoiceId}/status`,
        null,
        {
          params: {
            status,
            amount,
          },
        },
      );

      toast.success("Invoice status updated successfully");
      return response.data;
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message || "Failed to update invoice status",
      );
      throw err;
    }
  },

  getInvoiceById: (invoiceId: number) =>
    customFetch.get<ApiResponse<Invoice>>(
      `/api/v1/fee-and-payment/${invoiceId}`,
    ),
};

export default feesAndPaymentApis;
